'use client';

import { ErrorState } from '@/components/common/ErrorState/ErrorState';
import { GlobalFooter } from '@/components/features/GlobalFooter/GlobalFooter';
import { GlobalHeader } from '@/components/features/GlobalHeader/GlobalHeader';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';

export default function NotFoundPage() {
  const t = useTranslations('common.notFound');
  const router = useRouter();

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <GlobalHeader className="sticky top-[0px]" />
        <main className="flex-1 py-16 px-6 sp:py-10">
          <ErrorState
            title={t('title')}
            body={t('body')}
            action={{
              label: t('action.label'),
              onClick: () => router.replace('/'),
            }}
          />
        </main>
        <GlobalFooter />
      </div>
    </>
  );
}
